export default __webpack_public_path__ + "static/media/7.fe4d615e.png";